import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=83cb4874&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports